<app-title-bar titleText="i18n.core.navigation.editProfile"></app-title-bar>
<div class="row">
  <div class="col-lg-6 offset-lg-3 col-md-6 offset-md-3">
    <app-user-edit-form [userEditForm]="userEditForm" isAdd="false"></app-user-edit-form>
  </div>
</div>
<div class="row">
  <div class="col-lg-6 offset-lg-3 col-md-6 offset-md-3 d-md-flex justify-content-md-end">
    <button type="submit"
            class="btn btn-outline-primary"
            (click)="save()"
            [disabled]="!userEditForm.valid">
      {{ "i18n.shared.save" | translate }}
    </button>
  </div>
</div>
